import React from 'react';
import { ink } from '../../primitives.js';

const h = React.createElement;

/**
 * The lemon-slice spinner shown while cached data refreshes. Ticks in eighths.
 *
 * @param {object} p
 * @param {number} [p.size]
 * @param {string} [p.title]
 */
export function RevalidateDot({ size = 16, title = 'Refreshing cached data' }) {
  return h('span', { role: 'status', title, 'aria-label': title, className: 'mo-tick', style: { display: 'inline-block', width: size, height: size, borderRadius: '50%', border: ink(2), boxSizing: 'border-box', background: 'conic-gradient(var(--lime) 0 25%, var(--card) 25% 50%, var(--gold) 50% 75%, var(--card) 75%)', verticalAlign: '-2px' } });
}
